(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[639],{

/***/ 9346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company",
      function () {
        return __webpack_require__(9017);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_0__);

var ResponseErrorServerSide = function(err) {
    if (err.response) {
        var ref, ref1;
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message, "", "error");
    } else if (err.request) {
        // The request was made but no response was received
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    } else {
        // Something happened in setting up the request that triggered an Error
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponseErrorServerSide);


/***/ }),

/***/ 9017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ company; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/@coreui/react/dist/index.es.js
var index_es = __webpack_require__(4475);
// EXTERNAL MODULE: ./components/index.js + 23 modules
var components = __webpack_require__(9765);
// EXTERNAL MODULE: ./parts/landingpage/index.js + 9 modules
var landingpage = __webpack_require__(806);
// EXTERNAL MODULE: ./redux/toggleSlice.js
var toggleSlice = __webpack_require__(9756);
// EXTERNAL MODULE: ./parts/courier-services/index.js + 1 modules
var courier_services = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(7501);
;// CONCATENATED MODULE: ./parts/company/History/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 


function History(param) {
    var en_data = param.en_data, id_data = param.id_data, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content mb-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-our-office-location",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-12",
                            children: [
                                language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: decodeURIComponent(escape(en_data ? (0,base64.decode)(en_data) : ""))
                                    }
                                }),
                                language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: decodeURIComponent(escape(id_data ? (0,base64.decode)(id_data) : ""))
                                    }
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var company_History = (History);

;// CONCATENATED MODULE: ./parts/company/Journey/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 


function Journey(param) {
    var en_data = param.en_data, id_data = param.id_data, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content contents-journey mb-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-our-office-location",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-12",
                            children: [
                                language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: decodeURIComponent(escape(en_data ? (0,base64.decode)(en_data) : ""))
                                    }
                                }),
                                language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: decodeURIComponent(escape(id_data ? (0,base64.decode)(id_data) : ""))
                                    }
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var company_Journey = (Journey);

;// CONCATENATED MODULE: ./parts/company/OfficeLocation/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 

function OfficeLocation(param) {
    var en_data = param.en_data, id_data = param.id_data, en_desc = param.en_desc, id_desc = param.id_desc, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-5 mb-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-our-office-location",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "title",
                                        dangerouslySetInnerHTML: {
                                            __html: language === "EN" ? en_data : id_data
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: language === "EN" ? en_desc : id_desc
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: "https://www.google.com/maps/d/embed?mid=1DiYJf7yWi0eCpEenTbC2KM3bTL9of10&ehbc=2E312F",
                                    width: "100%",
                                    height: "300px"
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* harmony default export */ var company_OfficeLocation = (OfficeLocation);

;// CONCATENATED MODULE: ./parts/company/index.js





// EXTERNAL MODULE: ./utils/useLoading.js
var useLoading = __webpack_require__(471);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./components/ResponseErrorServerSide/index.js
var ResponseErrorServerSide = __webpack_require__(577);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
;// CONCATENATED MODULE: ./pages/company/index.js
/* eslint-disable jsx-a11y/alt-text */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/jsx-no-undef */ /* eslint-disable no-unused-vars */ 















function Company(param) {
    var product = param.product, landingPage = param.landingPage, headerFooter = param.headerFooter, company = param.company, coverageArea = param.coverageArea, isError = param.isError, lang = param.lang;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    // const language = useSelector((state) => state.toggle.language);
    var language = lang;
    var pathname = router.asPath.split("/").pop();
    var all_path = router.asPath.split("/");
    var ref31 = (0,react.useState)(false), visible = ref31[0], setVisible = ref31[1];
    var prevScrollY = (0,react.useRef)(0);
    var ref32 = (0,react.useState)(false), goingUp = ref32[0], setGoingUp = ref32[1];
    var loading = (0,useLoading/* useLoading */.r)(false);
    // seo
    var seo = product === null || product === void 0 ? void 0 : product.state;
    // ===
    // navbar
    var navbar = headerFooter === null || headerFooter === void 0 ? void 0 : (ref = headerFooter.state) === null || ref === void 0 ? void 0 : ref.header;
    // ===
    // banner
    var banner = landingPage === null || landingPage === void 0 ? void 0 : (ref1 = landingPage.state) === null || ref1 === void 0 ? void 0 : ref1.banner;
    // ===
    // coverageArea
    var CoverageArea = [];
    coverageArea === null || coverageArea === void 0 ? void 0 : (ref2 = coverageArea.state) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(item) {
        CoverageArea.push(item.jvector_code);
    });
    // ===
    // navigasi menu
    var navigasiMenu = landingPage === null || landingPage === void 0 ? void 0 : (ref3 = landingPage.state) === null || ref3 === void 0 ? void 0 : ref3.navigationMenu;
    // ===
    // hero
    var newDataHeader = {
        banner_img: product === null || product === void 0 ? void 0 : (ref4 = product.state) === null || ref4 === void 0 ? void 0 : ref4.banner_img,
        cta_btn_id: product === null || product === void 0 ? void 0 : (ref5 = product.state) === null || ref5 === void 0 ? void 0 : ref5.cta_btn_id,
        en_desc: product === null || product === void 0 ? void 0 : (ref6 = product.state) === null || ref6 === void 0 ? void 0 : ref6.en_desc,
        en_title: product === null || product === void 0 ? void 0 : (ref7 = product.state) === null || ref7 === void 0 ? void 0 : ref7.en_title,
        id_desc: product === null || product === void 0 ? void 0 : (ref8 = product.state) === null || ref8 === void 0 ? void 0 : ref8.id_desc,
        id_title: product === null || product === void 0 ? void 0 : (ref9 = product.state) === null || ref9 === void 0 ? void 0 : ref9.id_title,
        headerCTA: product === null || product === void 0 ? void 0 : (ref10 = product.state) === null || ref10 === void 0 ? void 0 : ref10.headerCTA,
        additional_cta_btn_id: product === null || product === void 0 ? void 0 : (ref11 = product.state) === null || ref11 === void 0 ? void 0 : ref11.additional_cta_btn_id,
        additionalCTA: product === null || product === void 0 ? void 0 : (ref12 = product.state) === null || ref12 === void 0 ? void 0 : ref12.additionalCTA
    };
    var dataHero = newDataHeader;
    // ===
    //company
    var newCompany = {
        en_history_txt: company === null || company === void 0 ? void 0 : (ref13 = company.state) === null || ref13 === void 0 ? void 0 : ref13.en_history_txt,
        id_history_txt: company === null || company === void 0 ? void 0 : (ref14 = company.state) === null || ref14 === void 0 ? void 0 : ref14.id_history_txt,
        en_journey_txt: company === null || company === void 0 ? void 0 : (ref15 = company.state) === null || ref15 === void 0 ? void 0 : ref15.en_journey_txt,
        id_journey_txt: company === null || company === void 0 ? void 0 : (ref16 = company.state) === null || ref16 === void 0 ? void 0 : ref16.id_journey_txt,
        en_office_location_txt: company === null || company === void 0 ? void 0 : (ref17 = company.state) === null || ref17 === void 0 ? void 0 : ref17.en_office_location_txt,
        id_office_location_txt: company === null || company === void 0 ? void 0 : (ref18 = company.state) === null || ref18 === void 0 ? void 0 : ref18.id_office_location_txt,
        en_office_location_desc: company === null || company === void 0 ? void 0 : (ref19 = company.state) === null || ref19 === void 0 ? void 0 : ref19.en_office_location_desc,
        id_office_location_desc: company === null || company === void 0 ? void 0 : (ref20 = company.state) === null || ref20 === void 0 ? void 0 : ref20.id_office_location_desc
    };
    var dataCompany = newCompany;
    // ===
    // services
    var dataServices = product === null || product === void 0 ? void 0 : product.state;
    var newServices = {
        en_service_text: dataServices === null || dataServices === void 0 ? void 0 : dataServices.en_service_text,
        id_service_text: dataServices === null || dataServices === void 0 ? void 0 : dataServices.id_service_text,
        OurServices: dataServices === null || dataServices === void 0 ? void 0 : dataServices.OurServices
    };
    var dataOurServices = newServices;
    // ===
    // client
    var newClient = {
        en_client_text: product === null || product === void 0 ? void 0 : (ref21 = product.state) === null || ref21 === void 0 ? void 0 : ref21.en_client_text,
        id_client_text: product === null || product === void 0 ? void 0 : (ref22 = product.state) === null || ref22 === void 0 ? void 0 : ref22.id_client_text,
        client: product === null || product === void 0 ? void 0 : (ref23 = product.state) === null || ref23 === void 0 ? void 0 : ref23.client
    };
    var dataClient = newClient;
    // ===
    // partner
    var newPartner = {
        id_partner_text: product === null || product === void 0 ? void 0 : (ref24 = product.state) === null || ref24 === void 0 ? void 0 : ref24.id_partner_text,
        en_partner_text: product === null || product === void 0 ? void 0 : (ref25 = product.state) === null || ref25 === void 0 ? void 0 : ref25.en_partner_text,
        partner: product === null || product === void 0 ? void 0 : (ref26 = product.state) === null || ref26 === void 0 ? void 0 : ref26.partner
    };
    var dataPartner = newPartner;
    // ===
    // cta fixed
    var dataCTA = product === null || product === void 0 ? void 0 : product.state;
    var newCTAFixed = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.stickyCTA), {
        sticky_cta_btn_id: dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.sticky_cta_btn_id
    });
    var dataCTAFixed = newCTAFixed;
    // ===
    // section cta
    var dataCTAsection = product === null || product === void 0 ? void 0 : product.state;
    var newDataCTA = dataCTAsection === null || dataCTAsection === void 0 ? void 0 : dataCTAsection.CTAButton;
    var dataCTASection = {
        newDataCTA: newDataCTA,
        en_cta_text: dataCTAsection === null || dataCTAsection === void 0 ? void 0 : dataCTAsection.en_cta_text,
        id_cta_text: dataCTAsection === null || dataCTAsection === void 0 ? void 0 : dataCTAsection.id_cta_text
    };
    // footer
    var footer = headerFooter === null || headerFooter === void 0 ? void 0 : (ref27 = headerFooter.state) === null || ref27 === void 0 ? void 0 : ref27.footer;
    // ===
    (0,react.useEffect)(function() {
        var ref;
        var handleScroll = function() {
            if (true) {
                var ref;
                var currentScrollY = window.scrollY;
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) < currentScrollY && goingUp) {
                    setGoingUp(false);
                }
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) > currentScrollY && !goingUp) {
                    setGoingUp(true);
                }
                var startY = (ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight;
                prevScrollY.current = currentScrollY;
                //
                if (currentScrollY > startY) {
                    var ref1;
                    var el = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el === null || el === void 0 ? void 0 : (ref1 = el.classList) === null || ref1 === void 0 ? void 0 : ref1.add("scrolled");
                } else {
                    var ref2;
                    var el1 = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el1 === null || el1 === void 0 ? void 0 : (ref2 = el1.classList) === null || ref2 === void 0 ? void 0 : ref2.remove("scrolled");
                }
            }
        };
        if (((ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight) > 0) {
            if (true) {
                window.addEventListener("scroll", function() {
                    handleScroll();
                });
                window.addEventListener("load", function() {
                    handleScroll();
                });
                window.addEventListener("resize", function() {
                    handleScroll();
                });
            }
        }
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        goingUp
    ]);
    var handleChangeLanguage = function() {
        if (language === "EN") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "ID"
            }));
            router.push("/company", "/company", {
                locale: "id"
            });
        } else {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "EN"
            }));
            router.push("/company", "/company", {
                locale: "en"
            });
        }
    };
    (0,react.useEffect)(function() {
        // check first load
        if (language === "ID") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "ID"
            }));
        }
        if (language === "EN") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "EN"
            }));
        }
    }, []);
    var topFunction = function() {
        setVisible(function(currentValue) {
            return !currentValue;
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var openNav = function() {
        document.getElementById("mySidenav").style.width = "320px";
    };
    var closeNav = function() {
        document.getElementById("mySidenav").style.width = "0";
    };
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingScreen */.a_, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponseErrorServerSide/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_seo_page_title : seo === null || seo === void 0 ? void 0 : seo.en_seo_page_title,
                description: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_desc : seo === null || seo === void 0 ? void 0 : seo.en_meta_desc,
                additionalMetaTags: [
                    {
                        property: "keywords",
                        content: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_keyword : seo === null || seo === void 0 ? void 0 : seo.en_meta_keyword
                    }
                ],
                additionalLinkTags: [
                    {
                        rel: "canonical",
                        href: "".concat("https://cklcargo.com/").concat(language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_slug : seo === null || seo === void 0 ? void 0 : seo.en_slug)
                    },
                    {
                        rel: "icon",
                        href: navbar === null || navbar === void 0 ? void 0 : navbar.web_icon
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCollapse */.V9, {
                        visible: visible,
                        id: "collapse-top-index",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card card-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BackgroundBannerDefault */.M4, {
                                    data: banner,
                                    language: language
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage/* MainContent */.M9, {
                                    language: language,
                                    data: navigasiMenu,
                                    CoverageArea: CoverageArea
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "col-top-nav",
                        className: "codrops-top codrops-top-for-page-detail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(courier_services/* NavbarCourierServices */.O, {
                                topFunction: topFunction,
                                data: navbar,
                                changeLanguage: handleChangeLanguage,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Sidebar */.DD, {
                                changeLanguage: handleChangeLanguage,
                                closeNav: closeNav,
                                openNav: openNav,
                                topFunction: topFunction,
                                data: navbar,
                                language: language
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-main-page col-main-page-detail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Hero */.VM, {
                                breadcrump: navbar,
                                language: language,
                                dataHeader: dataHero
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_History, {
                                en_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.en_history_txt,
                                id_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.id_history_txt,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Journey, {
                                en_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.en_journey_txt,
                                id_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.id_journey_txt,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_OfficeLocation, {
                                en_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.en_office_location_txt,
                                id_data: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.id_office_location_txt,
                                en_desc: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.en_office_location_desc,
                                id_desc: dataCompany === null || dataCompany === void 0 ? void 0 : dataCompany.id_office_location_desc,
                                language: language
                            }),
                            (dataOurServices === null || dataOurServices === void 0 ? void 0 : (ref28 = dataOurServices.OurServices) === null || ref28 === void 0 ? void 0 : ref28.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OurServices */.N3, {
                                language: language,
                                dataOurServices: dataOurServices === null || dataOurServices === void 0 ? void 0 : dataOurServices.OurServices,
                                en_service_text: dataOurServices === null || dataOurServices === void 0 ? void 0 : dataOurServices.en_service_text,
                                id_service_text: dataOurServices === null || dataOurServices === void 0 ? void 0 : dataOurServices.id_service_text
                            }),
                            (dataClient === null || dataClient === void 0 ? void 0 : (ref29 = dataClient.client) === null || ref29 === void 0 ? void 0 : ref29.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OurClient */.rh, {
                                client: dataClient === null || dataClient === void 0 ? void 0 : dataClient.client,
                                id_title: dataClient === null || dataClient === void 0 ? void 0 : dataClient.id_client_text,
                                en_title: dataClient === null || dataClient === void 0 ? void 0 : dataClient.en_client_text,
                                language: language
                            }),
                            (dataPartner === null || dataPartner === void 0 ? void 0 : (ref30 = dataPartner.partner) === null || ref30 === void 0 ? void 0 : ref30.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OurPartner */._Y, {
                                id_title: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.id_partner_text,
                                en_title: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.en_partner_text,
                                language: language,
                                partner: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.partner
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CTA */.MV, {
                                CTAButton: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.newDataCTA,
                                language: language,
                                id_desc: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.id_cta_text,
                                en_desc: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.en_cta_text
                            })
                        ]
                    }),
                    (dataCTAFixed === null || dataCTAFixed === void 0 ? void 0 : dataCTAFixed.sticky_cta_btn_id) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WAFixed */.Fs, {
                        data: dataCTAFixed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FooterFrontend */.YE, {
                        footer: footer,
                        language: language
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var company = (Company);


/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ courier_services_NavbarCourierServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/courier-services/NavbarCourierServices/index.js
/* eslint-disable no-unused-vars */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 




function NavbarCourierServices(param) {
    var topFunction = param.topFunction, data = param.data, changeLanguage = param.changeLanguage, language = param.language;
    // buat misahin posisi menu navbar
    var idFreeConsultation = 20;
    // buat conditional routing per id detail
    var idCourier = 2;
    var idInternational = 7;
    // buat redirect ke luar web
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                locale: language === "ID" ? "id" : "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : data.logo,
                        alt: data === null || data === void 0 ? void 0 : data.alt_logo,
                        // layout="fill"
                        width: 125,
                        height: 62
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "top-nav-menu",
                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        }),
                                                        child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "subs-nav",
                                                                children: child.child.map(function(childofchild, childofchildIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                locale: language === "ID" ? "id" : "en",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                })
                                                                            })
                                                                        }, childofchildIndex)
                                                                    });
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "ID" ? "/" + (item === null || item === void 0 ? void 0 : item.id_url) : "/" + (item === null || item === void 0 ? void 0 : item.en_url),
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    })
                                })
                            })
                        })
                    });
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu top-consultation",
                        children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                            return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                        locale: language === "ID" ? "id" : "en",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        })
                                                    })
                                                }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                    })
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://cklcargo.com/", "/assets/icons/globe.png"),
                                            width: 39,
                                            height: 30,
                                            alt: "ckl-logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: topFunction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat("https://cklcargo.com/", "/assets/icons/home.png"),
                            width: 39,
                            height: 30,
                            alt: "home"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var courier_services_NavbarCourierServices = (NavbarCourierServices);

;// CONCATENATED MODULE: ./parts/courier-services/index.js




/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* unused reexport */ __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,617,645,498,383,74,806,774,888,179], function() { return __webpack_exec__(9346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);